import { 
	Alert,
} from 'src/app/database-models';

export class AlertLookupGroup {
	alert : Alert;
}
